export default __webpack_public_path__ + "static/media/packet.7b969879.svg";